import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import classNames from 'classnames'
import { formatCurrency } from '../../helpers'
import { Article } from '../../redux-toolkits/lists/list.types'
import Icon from '../icon'

export const HPGoodList = ({
  article,
  id,
  sortable = false,
  className = '',
  onRemove,
}: {
  article: Article & { price?: number }
  id: string
  sortable?: boolean
  className?: string
  onRemove?: () => void
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      className={classNames(
        'relative w-full flex flex-col bg-frost',
        className,
      )}
      ref={setNodeRef}
      style={style}
    >
      <img
        src={article.bannerUrl}
        className="block w-full aspect-square object-cover rounded-md"
        alt={`banner`}
      />

      <p className="line-clamp-1 mt-2 text-black text-base font-medium">
        {article.title}
      </p>

      <p className="line-clamp-1 mt-0.5 text-black text-sm">{`Starting from ${formatCurrency(
        article?.price ?? 0,
      )}`}</p>

      {id && sortable ? (
        <div className="flex w-full items-end justify-center flex-1">
          <button
            className="w-fit cursor-grab mx-auto mt-4 !max-w-[50px]"
            {...attributes}
            {...listeners}
            type="button"
          >
            <Icon id="rearrange" width={24} height={24} />
          </button>
        </div>
      ) : undefined}

      {onRemove && (
        <button
          className={classNames(
            'p-2 bg-gray-bg rounded-full w-fit absolute top-4 right-4',
          )}
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
        >
          <Icon className="text-danger" width={20} height={20} id="bin" />
        </button>
      )}
    </div>
  )
}
